import axios from 'axios';
import store from '../store';
import DEFINES from '@/defines';
import router from '@/router';
import Vue from 'vue';

const HASH_ALGO = 'sha256';
const BASE_API_URL = DEFINES.BASE_API_URL;
const BUILD_MODE = process.env.VUE_APP_BUILD_MODE;
const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;
const API_DOMAIN = DEFINES.API_DOMAIN;

async function callApi (url, payload, isLoaderAllowed = true) {
  if (isLoaderAllowed) store.dispatch ('app/showLoader');
  return axios
    .post (BASE_API_URL + url, payload, buildHeaders ())
    .then (response => {
      return parseResponse (response);
    })
    .catch (error => {
      //catch axios errors
      if (error.response != undefined) {
        return parseHttpError (error.response);
      } else {
        //its rms server error data
        throw error;
      }
    })
    .finally (function () {
      if (isLoaderAllowed) store.dispatch ('app/hideLoader');
    });
}

async function handleError (error) {
  if (error.code == DEFINES.ERROR_TYPE.PRECONDITION_REQUIRED) {
    await store.dispatch ('app/showErrorMessageDialog', {
      error: error,
    });
  }
  if (error.code == DEFINES.ERROR_TYPE.INVALID_AUTHENTICATION) {
    await store.dispatch ('resetAll');
    router.push ({path: '/login'});
  }
  throw error;
}

const buildHeaders = () => {
  return {
    headers: {
      Authorization: 'Bearer ' + JSON.stringify(getAuthHash()),
    },
  };
};

const getSetCookieUrl = () => {
  return BASE_API_URL + '/stream/setCookie/' + JSON.stringify(getAuthHash());
};

const getAuthHash = () => {
  let nonce = require ('nonce') ();
  //FIXME: Implement Server Side Security
  let timestamp = '1' + nonce ();
  let key = store.state.auth.key;
  let secret = store.state.auth.secret;

  let signature = key + secret + timestamp;

  let hash = null;

  if (key && secret) {
    hash = doHash (signature);
  }

  return {
    key: store.state.auth.key,
    timestamp: timestamp,
    hash: hash,
    version: BUILD_VERSION,
    build_mode: BUILD_MODE,
  };

};

const doHash = req => {
  let shajs = require ('sha.js');
  let hash = shajs (HASH_ALGO).update (req).digest ('hex');
  return hash;
};

const parseHttpError = response => {
  //server is down
  //console.log (response);
  let error = response.status + ' : ' + response.statusText;
  //FIXME: have to handle http error here status field is not received from api response
};

const parseResponse = response => {
  // handleError(response.data.error)
  //2.  Non-handleable errors
  if (response.data.error) {
    return handleError (response.data.error);
  }

  //3. Data is OK
  if (response.status == 200) {
    // check version
    if (
      BUILD_MODE == 'PRODUCTION' &&
      response.data.version != DEFINES.APP_VERSION
    ) {
      store.dispatch ('app/showMessage', {
        message: 'We are about to update the APP',
        color: 'success',
      });
      router.push ({
        name: router.currentRoute.name,
        query: {version: response.data.version},
      });
    }
    return response.data.data;
  }

  //4. Unknown Stage
  throw {title: 'Unknown API response'};
};

export {callApi, parseHttpError, buildHeaders, getAuthHash, getSetCookieUrl};
